export abstract class KeysNoLoad {

    static readonly EDU_ATLAS_8: string[] = [
        'man', 'woman', 'girl', 'grandma', 'sailor'
    ];

    static readonly EDU_ATLAS_7: string[] = [
        'ancient', 'arch', 'builder_1', 'builder_2', 'builder_3', 'builder_4', 'builder_5', 'dark_serra', 'dark_serra_hood', 'dobbie',
        'exile', 'hs_1', 'hs_2', 'hs_3', 'kult_1', 'kult_2', 'kult_3', 'kult_4', 'loki', 'nargal', 'portal',
        'reaper_1', 'reaper_2', 'reaper_3', 'reaper_4', 'reaper_5', 'silap', 'silap_whirl', 'skuld', 'source', 'tonatiu', '{marko}', 'mar', 'marko', 'thor'
    ];

    static readonly EDU_ATLAS_6: string[] = [
        'anubis', 'bard', 'bastet', 'dark_alice_t', 'dark_johnny_t', 'dark_alice', 'dark_jonny', 'draugr', 'elder6',
        'garm', 'golem_4', 'golem_5', 'golem_6', 'golem_7', 'golem_8', 'gor', 'heart', 'helga', 'huldra',
        'keeper_1', 'keeper_2', 'keeper_3', 'keeper_4', 'keeper_5', 'keeper_6', 'keeper_7',
        'mara', 'osiris', 'peasant1', 'peasant2', 'peasant3', 'pharaoh', 'priestess_1', 'priestess_2',
        'urd', 'verdandi', 'vestnik', 'warrior_1', 'warrior_2', 'thor_golem', 'mouse'
    ];

    static readonly EDU_ATLAS_3: string[] = [
        'changming', 'ghost_1', 'ghost_2', 'ghost_3', 'ghost_4', 'monk',
        'ns_road_0', 'ns_road_1', 'ns_road_2', 'ns_road_3', 'ns_road_4', 'ns_road_5',
        'rokkara_1', 'rokkara_2', 'sigi-ghost', 'swl_4', 'swl_8', 'temple_3',
        'vill_1', 'vill_2', 'vill_3', 'vill_run_1', 'vill_run_2', 'vill_run_3', 'vill_run_4',
        'warlocks', 'white-rabbit-ghost', 'teller',
        'yot-01', 'yot-02', 'yot-03', 'yot-04', 'yot-05', 'yot-06', 'yot-07', 'yot-08', 'yot-09', 'yot-10', 'yot-11', 'yot-12'
    ];

    static readonly EDU_ATLAS_2: string[] = ['blind_older', 'ectelion', 'gektor', 'guild_mag', 'maya',
        'ming', 'sister', 'sun_dragon', 'maglor', 'gvindor', 'castle', 'rock'];

    static readonly GAINABLES_ATLAS_2: string[] = ['green_crystal', 'violet_crystal', 'sulfur', 'red_dust',
        'dragon_tulip', 'shadow_berry', 'volcano_crystal', 'mithril', 'collect-kukaryamba', 'pine_doom',
        'fate_roots', 'p3_keys', 'task-easter-egg'];

    static readonly EDU_ATLAS_SIDE_QUESTS: string[] = ['fat-man', 'ivan1', 'ivan2', 'tuzemec'];

    static readonly P9_DIALOG_ATLAS: string[] = [
        'p9_fire_elemental', 'prophecy_demon', 'dark_thor', 'ancient_spider',
        'light_shadow', 'rasul', 'abbess', 'harpy_queen', 'forgotten_soul',
        'ancient_werewolf', 'ancient_one_child_form', 'forest_demon',
        'void_warrior', 'faceless', 'p9_nun', 'p9_manticore'
    ];
}
